import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'breadcrumbs',
  initialState: [],
  reducers: {
    setBreadcrumbs: (_, { payload }) => {
      return payload
    },
  },
})

export const { setBreadcrumbs } = slice.actions

export default slice.reducer

export const selectBreadcrumbs = (state) => state.ui.breadcrumbs
